__turbopack_context__.v({
  "addToCartButtonContent": "UpsellCardUIComponents-module__yLFgUa__addToCartButtonContent",
  "addedToCartDisclaimer": "UpsellCardUIComponents-module__yLFgUa__addedToCartDisclaimer",
  "backdrop": "UpsellCardUIComponents-module__yLFgUa__backdrop",
  "baseAddToCartButton": "UpsellCardUIComponents-module__yLFgUa__baseAddToCartButton",
  "cardBottomSection": "UpsellCardUIComponents-module__yLFgUa__cardBottomSection",
  "cardTopSection": "UpsellCardUIComponents-module__yLFgUa__cardTopSection",
  "container": "UpsellCardUIComponents-module__yLFgUa__container",
  "content": "UpsellCardUIComponents-module__yLFgUa__content",
  "ctaContainer": "UpsellCardUIComponents-module__yLFgUa__ctaContainer",
  "description": "UpsellCardUIComponents-module__yLFgUa__description",
  "fadeIn": "UpsellCardUIComponents-module__yLFgUa__fadeIn",
  "fadeOut": "UpsellCardUIComponents-module__yLFgUa__fadeOut",
  "hidden": "UpsellCardUIComponents-module__yLFgUa__hidden",
  "imageContainer": "UpsellCardUIComponents-module__yLFgUa__imageContainer",
  "learnMoreLink": "UpsellCardUIComponents-module__yLFgUa__learnMoreLink",
  "priceContainer": "UpsellCardUIComponents-module__yLFgUa__priceContainer",
  "tag": "UpsellCardUIComponents-module__yLFgUa__tag",
  "title": "UpsellCardUIComponents-module__yLFgUa__title",
  "visible": "UpsellCardUIComponents-module__yLFgUa__visible",
});
